//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[[0,"Group",1,0],[0,"Volume",1,0]],[[["ngroups"],"GetGroups",{R_:{groups:""}},0,0],[["nvolumes"],"GetVolumes",{R_:{volumes:""}},0,0],[[],"Apply",{},0,0],[[],"Dispose",{},0,0]],[]];
SPLM.PDM.PersistentSettings = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PersistentSettings";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;